// Window dressing that is set ONCE, at app start, and never per screen.
//
// Imported for its side effect by every page, not called from main.js: main.js
// is factory-owned and rewritten by `appfactory upgrade`, and a module runs its
// top level exactly once however many importers it has. Whichever screen the
// app opens on — including a warning push deep-linking straight to
// /warnings/:id — this has already run.
//
// The status bar is the reason it exists. Paper is light, so the bar needs DARK
// content on every screen. Setting it per page is what produces a bar that
// changes style when you switch tabs, which reads as a bug even when each
// individual screen is right.

import { plugin, isNative } from './core/native.js';

const PAPER = '#DFE3D1';

// Ionic ships a dark scheme and index.html asks for it. Overhead has one look:
// there is no dark variant of chart-recorder paper, and inverting it would set
// rust hairlines glowing on black.
if (typeof document !== 'undefined') {
  document.documentElement.setAttribute('data-scheme', 'light');
  document.documentElement.classList.remove('ion-palette-dark');
}

function applyStatusBar() {
  if (!isNative) return false;
  const StatusBar = plugin('StatusBar');
  if (!StatusBar?.setStyle) return false;
  try {
    // Style.Light means a LIGHT BACKGROUND with dark content, which is the way
    // round this app needs and the opposite of what the name suggests.
    StatusBar.setStyle({ style: 'LIGHT' });
    // Android only; iOS ignores it. The paper runs under the bar either way
    // because ConditionsHead pads itself by env(safe-area-inset-top).
    StatusBar.setBackgroundColor?.({ color: PAPER });
    StatusBar.setOverlaysWebView?.({ overlay: true });
    return true;
  } catch {
    return false;   // a build without the plugin keeps the platform default
  }
}

applyStatusBar();

export { applyStatusBar };
